import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  container: ({ downSized }) => ({
    marginBottom: downSized ? '12px' : '17px',
  }),
  spacing: ({ downSized }) => ({
    marginTop: downSized ? '8px' : '16px',
  }),
  downSizedFont: {
    fontSize: '1.14rem',
  },
  status: {
    marginLeft: theme.spacing(1),
    color: 'grey',
  },
  substatus: {
    color: '#CC010A',
  },
}));
